// extracted by mini-css-extract-plugin
export default {"weather":"Weather_weather__IdNyf"};